import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router';

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    // eslint-disable-next-line react/prop-types
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    // eslint-disable-next-line react/prop-types
    return this.props.children
  }
}

export default withRouter(ScrollToTop);